'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    { PropTypes } = React;

require('./AudioProgress.less');

var MIN_PROGRESS = 0.005;

var AudioProgress = React.createClass({
  mixins: [PureRenderMixin, ClassNameMixin],

  propTypes: {
    trackDuration: PropTypes.number.isRequired,
    currentTime: PropTypes.number.isRequired,
    onChangeTime: PropTypes.func.isRequired
  },

  handleChangeTime(event) {
    var clickOffset = event.pageX,
        clickTarget = event.target,
        width = this.getDOMNode().offsetWidth;

    if (width === 0) {
      return;
    }

    while (clickTarget) {
      clickOffset -= clickTarget.offsetLeft;
      clickTarget = clickTarget.offsetParent;
    }

    var time = Math.min(
      Math.ceil(clickOffset * this.props.trackDuration / width),
      this.props.trackDuration
    );

    this.props.onChangeTime(time);
  },

  render() {
    var { currentTime, trackDuration } = this.props,
        progress = 0;

    if (currentTime && trackDuration) {
      progress = Math.max(MIN_PROGRESS, currentTime / trackDuration);
    }

    return (
      <div className={this.getClassName()}
           onClick={this.handleChangeTime}>
        <div className='AudioProgress-currentTime'
             style={{
               width: Math.round(progress * 100) + '%'
             }} />
      </div>
    );
  }
});

module.exports = AudioProgress;



/** WEBPACK FOOTER **
 ** ./atoms/AudioProgress.jsx
 **/